<template>
    <div class="plugin-home-hero-item">
        <div class="plugin-home-hero-item__title">{{ title }}</div>
        <div class="plugin-home-hero-item__description">{{ description }}</div>
    </div>
</template>

<script>
export default {
    name: 'plugin-home-hero-v2-item',
    props: {
        title: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            default: null,
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-hero-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    &__title {
        font-size: 54px;
        line-height: 54px;
        font-weight: bold;
        text-align: center;
    }

    &__description {
        .typography-heading();

        font-weight: bold;
        text-align: center;
    }

    @media (min-width: 2000px) {
        &__title {
            font-size: 64px;
            line-height: 68px;
        }
        &__description {
            .typography-body-lg();
        }
    }
    @media @media-sm-down {
        &__title {
            font-size: 28px;
            line-height: 34px;
            font-weight: bold;
        }
    }
}
</style>
